import React, { useState, useEffect } from 'react';
import axios from 'axios';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import ViewHeadlineOutlinedIcon from '@material-ui/icons/ViewHeadlineOutlined';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import HotelAccommodationForm from './hotel-accommodation-form';
import HotelMeetingForm from './hotel-meeting-form';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import { checkTokenExpirationMiddleware } from '../../../../middlewares/users-auth.middleware';
import { createUploadState, uploadSelectedFile } from '../../../../helpers/attachment-helper';
import * as SupplierTypes from '../../../../magic-strings/supplier-type';
import CustomSelect from '../custom-select';


const HotelOfferForm = ({ handleReloadOffers, reservationReqId, hotelResources }) => {
    const [acommodationOffered, setAcommodationOffered] = useState(false);
    const [meetingOffered, setMeetingOffered] = useState(false);

    const [hotel, setHotel] = useState(null);
    const [user] = useState(checkTokenExpirationMiddleware());
    const [loader, setLoader] = useState(false);
    const [success, setSuccess] = useState(null);
    const [serverError, setServerError] = useState(null);
    const [error, setError] = useState(null);
    const [accommodationAttachmentUpload, setAccommodationAttachmentUpload] = useState(createUploadState());
    const [coffeeBreakUpload, setCoffeeBreakUpload] = useState(createUploadState());
    const [lunchUpload, setLunchUpload] = useState(createUploadState());
    const [meetingAttachmentUpload, setMeetingAttachmentUpload] = useState(createUploadState());

    useEffect(() => {
        let hotels = [];
        if (user.SupplierType === SupplierTypes.Hotel) {
            let headers = { "Authorization": `Bearer ${user.Token}` };
            axios.get(`/api/userhotel`, { headers: headers })
                .then(res => {
                    let userHotels = res.data;
                    for (let i = 0; i < userHotels.length; i++) {
                        let hotel = {
                            key: userHotels[i].key,
                            value: userHotels[i].value
                        };
                        hotels.push(hotel);
                    }
                    setHotel([...hotels]);
                });
        }
        else if (user.SupplierType === SupplierTypes.TourismCompany) {
            for (let i = 0; i < hotelResources.length; i++) {
                let hotel = {
                    key: hotelResources[i].hotelId,
                    value: hotelResources[i].hotelName
                };
                hotels.push(hotel);
            }
        }
        setHotel(hotels);
    }, []);

    const handleAccommodationAttachmentChange = async (event) => {
        await uploadSelectedFile({
            file: event.target.files.length > 0 ? event.target.files[0] : null,
            category: "hotel",
            token: user.Token,
            setUploadState: setAccommodationAttachmentUpload
        });
    };

    const handleCoffeeBreakChange = async (event) => {
        await uploadSelectedFile({
            file: event.target.files.length > 0 ? event.target.files[0] : null,
            category: "hotel",
            token: user.Token,
            setUploadState: setCoffeeBreakUpload
        });
    };

    const handleLunchChange = async (event) => {
        await uploadSelectedFile({
            file: event.target.files.length > 0 ? event.target.files[0] : null,
            category: "hotel",
            token: user.Token,
            setUploadState: setLunchUpload
        });
    };

    const handleMeetingAttachmentChange = async (event) => {
        await uploadSelectedFile({
            file: event.target.files.length > 0 ? event.target.files[0] : null,
            category: "hotel",
            token: user.Token,
            setUploadState: setMeetingAttachmentUpload
        });
    };

    const submitOffer = (event) => {
        event.preventDefault();
        setLoader(true);
        setSuccess(null);
        setError(null);
        let hotelOfferResource = new FormData();
        hotelOfferResource.append("ReservationReqId", reservationReqId);
        hotelOfferResource.append("HotelId", parseInt(event.target.querySelector("#ho-te input").value));
        hotelOfferResource.append("OfferHeadline", event.target.querySelector("#hd-ln").value);

        const accommodationAttachmentInput = event.target.querySelector("#ho-aco #file-attach");
        const coffeeBreakInput = event.target.querySelector(".coffe-attach");
        const lunchInput = event.target.querySelector(".meal-attach");
        const meetingAttachmentInput = event.target.querySelector(".file-attach");
        const uploadStates = [
            { input: accommodationAttachmentInput, state: accommodationAttachmentUpload },
            { input: coffeeBreakInput, state: coffeeBreakUpload },
            { input: lunchInput, state: lunchUpload },
            { input: meetingAttachmentInput, state: meetingAttachmentUpload }
        ];

        if (uploadStates.some(item => item.state.uploading)) {
            setError("One or more attachment uploads are still in progress.");
            setLoader(false);
            return;
        }

        const failedUpload = uploadStates.find(item => item.input && item.input.files.length > 0 && !item.state.blobPath);
        if (failedUpload) {
            setError(failedUpload.state.error || "Upload the selected files before submitting the offer.");
            setLoader(false);
            return;
        }

        // --------- Collect Hotel Acommodation ------------------
        let hotelAcommodationResources = [];
        let hoteAcommodationRoomResources = [];
        let hotelAcommodationRooms = event.target.querySelectorAll("#ho-aco .ro-rw");
        let hotelAcommodationTextareas = event.target.querySelectorAll("#ho-aco textarea");
        for (let i = 0; i < hotelAcommodationRooms.length; i++) {
            let hotelAcommodationRoomInputs = hotelAcommodationRooms[i].querySelectorAll("input");
            let hoteAcommodationRoomResource = {
                CheckIn: hotelAcommodationRoomInputs[0].value,
                CheckOut: hotelAcommodationRoomInputs[1].value,
                RoomCategoryId: parseInt(hotelAcommodationRoomInputs[2].value),
                RoomTypeId: parseInt(hotelAcommodationRoomInputs[3].value),
                MealPlanId: parseInt(hotelAcommodationRoomInputs[4].value),
                NoofRooms: parseInt(hotelAcommodationRoomInputs[5].value),
                RoomPrice: hotelAcommodationRoomInputs[6].value,
            };
            hoteAcommodationRoomResources.push(hoteAcommodationRoomResource);
        }
        if (hotelAcommodationTextareas.length > 0) {
            let hotelAcommodationResource = {
                PaymentPolicy: hotelAcommodationTextareas[0].value,
                FreePolicy: hotelAcommodationTextareas[1].value,
                CancellationPolicy: hotelAcommodationTextareas[2].value,
                ChildrenPolicy: hotelAcommodationTextareas[3].value,
                Notes: hotelAcommodationTextareas[4].value,
                ReservationSupplierHotelAccommodationRoomResources: hoteAcommodationRoomResources
            };
            hotelOfferResource.append("AcommodationAttachmentFile", accommodationAttachmentUpload.blobPath ? accommodationAttachmentUpload.blobPath : "");
            hotelAcommodationResources.push(hotelAcommodationResource);
        }
        // -------- End Hotel Acommodation ---------------------


        // --------- Collect Hotel Meeting ------------------
        let hotelMeetingRoomsResources = [];

        let hotelMeetingRooms = event.target.querySelectorAll(".ho-me");
        for (let i = 0; i < hotelMeetingRooms.length; i++) {
            let hotelMeetingRoomTextAreas = hotelMeetingRooms[i].querySelectorAll("textarea");
            let hotelMeetingRoomInputs = hotelMeetingRooms[i].querySelectorAll("input");

            let hotelMeetingRoomsResource = {
                MeetingDate: hotelMeetingRoomInputs[0].value,
                MeetingTime: hotelMeetingRoomInputs[1].value,
                RoomSetup: hotelMeetingRoomInputs[2].value,
                //CoffeeBreakMenu: hotelMeetingRoomTextAreas[0].value.trim() === "" ? null : hotelMeetingRoomTextAreas[0].value.trim(),
                //CoffeeBreakMenu: hotelMeetingRooms[i].querySelector(".coffe-attach").files.length < 1 ? null : hotelMeetingRooms[i].querySelector(".coffe-attach").files[0],
                CoffeeBreakMenu: null,
                CoffeeBreakTime: hotelMeetingRoomInputs[4].value === "" ? null : hotelMeetingRoomInputs[4].value,
                CoffeeBreakPrice: hotelMeetingRoomInputs[5].value === "" ? null : parseFloat(hotelMeetingRoomInputs[5].value),
                //LunchOrDinnerMenu: hotelMeetingRoomTextAreas[1].value.trim() === "" ? null : hotelMeetingRoomTextAreas[1].value.trim(),
                LunchOrDinnerMenu: null,
                //LunchOrDinnerMenu: hotelMeetingRooms[i].querySelector(".meal-attach").files.length < 1 ? null : hotelMeetingRooms[i].querySelector(".meal-attach").files[0],
                LunchOrDinnerTime: hotelMeetingRoomInputs[7].value === "" ? null : hotelMeetingRoomInputs[7].value,
                LunchOrDinnerPrice: hotelMeetingRoomInputs[8].value === "" ? null : parseFloat(hotelMeetingRoomInputs[8].value),
                MeetingRoomName: hotelMeetingRoomInputs[9].value,
                MeetingRoomCapacity: parseInt(hotelMeetingRoomInputs[10].value),
                MeetingPackagePrice: parseFloat(hotelMeetingRoomInputs[11].value),
                PaymentPolicy: hotelMeetingRoomTextAreas[0].value,
                CancellationPolicy: hotelMeetingRoomTextAreas[1].value,
                FreePolicy: hotelMeetingRoomTextAreas[2].value,
                Notes: hotelMeetingRoomTextAreas[3].value,
                //AttachmentFile: hotelMeetingRooms[i].querySelector(".file-attach").files.length < 1 ? null : hotelMeetingRooms[i].querySelector(".file-attach").files[0],
                ReservationSupplierHotelMeetingEquipmentResources: []
            };
            let hotelMeetingRoomEquipments = hotelMeetingRooms[i].querySelectorAll(".eq-rw");
            for (let i = 0; i < hotelMeetingRoomEquipments.length; i++) {
                let hotelMeetingRoomEquipmentInputs = hotelMeetingRoomEquipments[i].querySelectorAll("input");
                let hotelMeetingRoomEquipmentResource = {
                    EquipmentId: parseInt(hotelMeetingRoomEquipmentInputs[0].value),
                    AvailableItems: hotelMeetingRoomEquipmentInputs[1].value,
                    ItemPrice: hotelMeetingRoomEquipmentInputs[2].value,
                };
                hotelMeetingRoomsResource.ReservationSupplierHotelMeetingEquipmentResources.push(hotelMeetingRoomEquipmentResource);
            }
            hotelOfferResource.append("CoffeeBreakMenuFile", coffeeBreakUpload.blobPath ? coffeeBreakUpload.blobPath : "");
            hotelOfferResource.append("LunchOrDinnerMenuFile", lunchUpload.blobPath ? lunchUpload.blobPath : "");
            hotelOfferResource.append("MeetingAttachmentFile", meetingAttachmentUpload.blobPath ? meetingAttachmentUpload.blobPath : "");
            hotelMeetingRoomsResources.push(hotelMeetingRoomsResource);
        }
        // -------- End Hotel Meeting ---------------------
        hotelOfferResource.append("ReservationSupplierHotelAccommodationResourcesJson", JSON.stringify(hotelAcommodationResources));
        hotelOfferResource.append("ReservationSupplierHotelMeetingResourcesJson", JSON.stringify(hotelMeetingRoomsResources));

        let headers = {
            "Accept": "application/json",
            "Authorization": `Bearer ${user.Token}`,
            "Content-Type": "multipart/form-data",
            "Content-Encoding": "gzip"
        };
        axios.post(`/api/hoteloffer`, hotelOfferResource, { headers: headers })
            .then(res => {
                setSuccess(true);
                setTimeout(() => {
                    setLoader(false);
                    handleReloadOffers();
                    setAcommodationOffered(false);
                    setMeetingOffered(false);
                }, 750);
            })
            .catch(err => {
                let errorMsg = "Error Adding Offer — Try again later!";
                if (err.response && err.response.data) {
                    const data = err.response.data;
                    if (data.errors) {
                        errorMsg = Object.values(data.errors).flat().join(" | ");
                    } else if (typeof data === "string") {
                        errorMsg = data;
                    }
                }
                setServerError(errorMsg);
                setSuccess(false);
                setTimeout(() => setLoader(false), 750);
            });
    }

    return (
        <>
            <Backdrop className={"backdrop"} open={loader}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <form onSubmit={submitOffer}>
                <Grid
                    container
                >
                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="hd-ln"
                                label={"Offer Headline"}
                                helperText={"Write an uniqe/request offer headline. Recommended to contain your company name and the word 'hotel'(ex: CoolCompany Hotel Offer 1, CoolCompany Exclusive Hotel offer)"}
                                fullWidth
                                type={"text"}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <ViewHeadlineOutlinedIcon fontSize={"small"} />
                                        </InputAdornment>
                                    )
                                }}
                                required
                            />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={12} sm={6} id="ho-te">
                            {
                                hotel ?
                                    <CustomSelect
                                        data={hotel}
                                        label={"Hotel"}
                                        required={true}
                                        icon={<BusinessOutlinedIcon fontSize={"small"} />}
                                    />
                                    : null
                            }
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={6} sm={4} >
                            {
                                hotel ?
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={acommodationOffered}
                                                onChange={(event) => setAcommodationOffered(event.target.checked)}
                                                name="checkedB"
                                                color="primary"
                                            />
                                        }
                                        label="Acommodation"
                                    />
                                    : null
                            }
                        </Grid>
                        <Grid item xs={6} sm={4} >
                            {
                                hotel ?
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={meetingOffered}
                                                onChange={(event) => setMeetingOffered(event.target.checked)}
                                                name="checkedB"
                                                color="primary"
                                            />
                                        }
                                        label="Meeting Room"
                                    />
                                    : null
                            }
                        </Grid>
                    </Grid>
                    {
                        acommodationOffered ?
                            <HotelAccommodationForm
                                attachmentUpload={accommodationAttachmentUpload}
                                onAttachmentChange={handleAccommodationAttachmentChange}
                            />
                            : null
                    }
                    <Divider style={{ width: `100%` }} />
                    {
                        meetingOffered ?
                            <HotelMeetingForm
                                index={0}
                                coffeeBreakUpload={coffeeBreakUpload}
                                lunchUpload={lunchUpload}
                                attachmentUpload={meetingAttachmentUpload}
                                onCoffeeBreakChange={handleCoffeeBreakChange}
                                onLunchChange={handleLunchChange}
                                onAttachmentChange={handleMeetingAttachmentChange}
                            />
                            : null
                    }
                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={12} sm={6}>
                            {
                                error ?
                                    <Alert variant="filled" severity="error">{error}</Alert>
                                    : null
                            }
                            {
                                success === false ?
                                    <Alert variant="filled" severity="error">{serverError || "Error Adding Offer — Try again later!"}</Alert>
                                    : null
                            }
                            {
                                success === true ?
                                    <Alert variant="filled" severity="success">Offer Added Successfully</Alert>
                                    : null
                            }
                        </Grid>
                    </Grid>

                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={12} sm={6}>
                            {
                                acommodationOffered || meetingOffered ?
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                    >
                                        Submit Offer
                                    </Button>
                                    : null
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}

export default HotelOfferForm;
